<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          sort: 'DESC',
          list_type: 'short',
          auth_role: 1
        }

        this.list = []

        await get('layanan', { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            let data = res.data

            data.map((obj) => {
              this.list.push({
                text: obj.layanan_nama,
                value: obj.layanan_kode
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'master_data_dukung',

          // SINGLE
          single: false,

          // CHECKBOX
          checkbox: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Kode Layanan',
              width: '100px',
              value: 'mdadu_layanan_kode',
              freeze: false,
              hide: false
            },
            {
              text: 'Judul',
              width: '200px',
              value: 'mdadu_judul',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Keterangan',
              width: '400px',
              value: 'mdadu_desc',
              freeze: false,
              hide: false,
              format: 'regex'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: 'mdadu_',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'layanan_kode',
              label: 'Kode Layanan',
              type: 'select',
              placeholder: 'Contoh. KK (Kartu Keluarga)',
              value: '',
              option: this.list,
              width: '60%',
              required: true,
              rules: 'required'
            },
            {
              field: 'judul',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Upload foto KK',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'desc',
              label: 'Deskripsi',
              type: 'texteditor',
              placeholder: 'Contoh. Tuliskan deskripsi disini',
              value: '',
              rows: 5,
              required: false
            },
            {
              field: 'image',
              label: 'Gambar',
              type: 'image',
              placeholder: 'Contoh. https://via.placeholder.com/640x480.png/0000bb?text=images+ex',
              value: '',
              width: '100%',
              required: false
            },
            {
              field: 'is_required',
              label: 'Is Required',
              type: 'radio',
              placeholder: 'Contoh. Required',
              value: 0,
              option: [
                {
                  text: 'Wajib',
                  value: 1
                },
                {
                  text: 'Tidak Wajib',
                  value: 0
                }
              ]
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'master_data_dukung/create',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'master_data_dukung/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'master_data_dukung/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>